import routes from "./routes";
import Home from "../pages/Home/Home";
import CalculadoraTFG from "../pages/Calculator/Calculator";
import BaseDocumental from "../pages/BaseDocumental/BaseDocumental";
import Enlaces from "../pages/Enlaces/Enlaces";
import Result from "../pages/Result/Result";
import NotFound from "../pages/404/NotFound";
import Login from "../pages/Login/Login";
import Master from "../pages/Masters/Masters";
import TablaRecibos from "../pages/Report/ReportGenerator";
import ReportesNormativos from "../pages/Report/ReportesNormativos";
import Dashboard from "../pages/Dashboard/Dashboard";
import IndicadorGubernamental from "../pages/IndicadorGubernamental/IndicadorGubernamental";
import RegistroPAI from "../pages/PAI/RegistroPAI";
import PlanParto from "../pages/PlanParto/PlanParto";
import Citologia from "../pages/citologia/Citologia";
import CarguePacientesMasivos from "../pages/carguePacientesMasivos/CarguePacientesMasivos";
import LogServices from "../pages/logServices/LogServices";
import { ROUTE_PERMISSIONS } from "./routePermissions";

import Support from "../pages/Support/Support";
import PatientPortalLogin from "../pages/PatientPortal/PatientPortalLogin";
import PatientPortalDashboard from "../pages/PatientPortal/PatientPortalDashboard";

const routesConfig = [
  { path: routes.home, element: <Home />, permission: ROUTE_PERMISSIONS[routes.home] },
  { path: routes.calculadora, element: <CalculadoraTFG />, permission: ROUTE_PERMISSIONS[routes.calculadora] },
  { path: routes.baseDocumental, element: <BaseDocumental />, permission: ROUTE_PERMISSIONS[routes.baseDocumental] },
  { path: routes.enlaces, element: <Enlaces />, permission: ROUTE_PERMISSIONS[routes.enlaces] },
  { path: routes.resultados, element: <Result />, permission: ROUTE_PERMISSIONS[routes.resultados] },
  { path: routes.maestro, element: <Master />, permission: ROUTE_PERMISSIONS[routes.maestro] },
  { path: routes.informe, element: <TablaRecibos />, permission: ROUTE_PERMISSIONS[routes.informe] },
  { path: routes.reportesNormativos, element: <ReportesNormativos />, permission: ROUTE_PERMISSIONS[routes.reportesNormativos] },
  { path: routes.dashboard, element: <Dashboard />, permission: ROUTE_PERMISSIONS[routes.dashboard] },
  { path: routes.indicadorGubernamental, element: <IndicadorGubernamental />, permission: ROUTE_PERMISSIONS[routes.indicadorGubernamental] },
  { path: routes.paiRegistro, element: <RegistroPAI />, permission: ROUTE_PERMISSIONS[routes.paiRegistro] },
  { path: routes.planParto, element: <PlanParto />, permission: ROUTE_PERMISSIONS[routes.planParto] },
  { path: routes.citologia, element: <Citologia />, permission: ROUTE_PERMISSIONS[routes.citologia] },
  { path: routes.carguePacientesMasivos, element: <CarguePacientesMasivos />, permission: ROUTE_PERMISSIONS[routes.carguePacientesMasivos] },
  { path: routes.logsServicios, element: <LogServices />, permission: ROUTE_PERMISSIONS[routes.logsServicios] },
  { path: routes.soporte, element: <Support />, permission: ROUTE_PERMISSIONS[routes.soporte] },
  { path: routes.patientPortal, element: <PatientPortalDashboard />, public: true },
  { path: routes.patientPortalLogin, element: <PatientPortalLogin />, public: true },
  { path: routes.login, element: <Login />, public: true },
  { path: routes.error, element: <NotFound />, public: true },
];

if (process.env.NODE_ENV === "development") {
  try {
    const configured = new Set(routesConfig.map((r) => r.path));
    const allowed = new Set([routes.login, routes.error]);
    const dangling = Object.values(routes).filter((p) => !allowed.has(p) && !configured.has(p));

    if (dangling.length > 0) {
      console.warn("[Guard Rail] ⚠️ Rutas definidas en routes.js sin registro en routesConfig:", dangling);
    }
  } catch (e) {
    console.warn("[Guard Rail] ⚠️ No se pudo validar consistencia de rutas:", e);
  }
}


export default routesConfig;
